import React from "react";

import Mousetrap from "mousetrap";
import "mousetrap/plugins/global-bind/mousetrap-global-bind";

interface GlobalKeyboardListenerProps {
	onEvent: (event: Mousetrap.ExtendedKeyboardEvent) => void;
	sequence: string;
	global?: boolean;
}

export default class GlobalKeyboardListener extends React.Component<GlobalKeyboardListenerProps> {
	handleKeypress = (event: Mousetrap.ExtendedKeyboardEvent): void => {
		this.props.onEvent(event);
	};

	componentDidMount() {
		if (this.props.global) {
			Mousetrap.bindGlobal(this.props.sequence, this.handleKeypress);
		} else {
			Mousetrap.bind(this.props.sequence, this.handleKeypress);
		}
	}

	componentWillUnmount() {
		Mousetrap.unbind(this.props.sequence);
	}

	render() {
		return null;
	}
}
